import { chakra } from '@chakra-ui/react';

const Row = chakra('div', { base: { display: 'inline-flex', alignItems: 'center', gap: '2.5', minWidth: 0 } });

/** The EHE pink wordmark lockup — the brand signature. Pink is identity, never an action
 *  colour; dark ink on pink keeps it AA. */
const Lockup = chakra('span', {
  base: {
    display: 'inline-flex',
    alignItems: 'center',
    px: '2',
    py: '1',
    borderRadius: 'md',
    bg: 'brand.solid',
    color: 'brand.onSolid',
    fontFamily: 'heading',
    fontWeight: 'extrabold',
    fontSize: 'lg',
    letterSpacing: 'tighter',
    lineHeight: 'none',
  },
});

const Sub = chakra('span', {
  base: { fontFamily: 'body', fontSize: 'sm', color: 'text.secondary', whiteSpace: 'nowrap' },
});

export interface BrandMarkProps {
  /** Hide the "Agent Platform" subtitle (e.g. the collapsed rail). */
  compact?: boolean;
}

/** The console brand mark: the pink "EHE" lockup + a quiet product subtitle. */
export function BrandMark({ compact = false }: BrandMarkProps) {
  return (
    <Row>
      <Lockup>EHE</Lockup>
      {!compact && <Sub>Agent Platform</Sub>}
    </Row>
  );
}
